const options: any = {
    client_id: process.env.REACT_APP_HARAVAN_CLIENT_ID,
    api_url: process.env.REACT_APP_API_URL ?? 'https://localhost:7054',
    myharavan: process.env.REACT_APP_MY_HARAVAN ?? 'myharavan.com',
    authority: process.env.REACT_APP_AUTHORITY ?? 'https://accounts.haravan.com'
}

export default options;
